import React, { useRef, useEffect } from 'react'
import SignatureCanvas from 'react-signature-canvas'

const SignaturePad = ({ handleInputChange }) => {
  const sigCanvas = useRef(null)
  const saveTimeoutRef = useRef(null) // To store the timeout reference

  useEffect(() => {
    const canvas = sigCanvas.current.getCanvas()
    const context = canvas.getContext('2d')

    // Adjust canvas for high DPI (Retina displays)
    const adjustCanvasSize = () => {
      const ratio = window.devicePixelRatio || 1
      const width = canvas.offsetWidth
      const height = canvas.offsetHeight

      // Scale the canvas drawing area based on pixel ratio
      canvas.width = width * ratio
      canvas.height = height * ratio
      context.scale(ratio, ratio)
    }

    adjustCanvasSize() // Call once on component mount

    window.addEventListener('resize', adjustCanvasSize) // Recalculate on window resize
    return () => window.removeEventListener('resize', adjustCanvasSize)
  }, [])

  const saveSignature = () => {
    const dataURL = sigCanvas.current.getTrimmedCanvas().toDataURL('image/png')
    handleInputChange("applicantSignature", dataURL)
  }

  const delayedSaveSignature = () => {
    clearTimeout(saveTimeoutRef.current)
    saveTimeoutRef.current = setTimeout(() => {
      saveSignature()
    }, 2000) // 2-second delay
  }

  const clearCanvas = () => {
    sigCanvas.current.clear()
    clearTimeout(saveTimeoutRef.current)
    handleInputChange("applicantSignature", null)
  }

  return (
    <>
      <div>
        <SignatureCanvas
          ref={sigCanvas}
          penColor="black"
          onEnd={delayedSaveSignature}
          canvasProps={{
            width: 500,
            height: 200,
            className: 'sigCanvas',
            style: { border: '1px solid black', cursor: 'crosshair', width: '100%', height: '200px' }
          }}
        />
      </div>
      <div>
        <button className='custButton delete' onClick={clearCanvas}>Clear</button>
      </div>
    </>
  )
}

export default SignaturePad
